import { useEffect, useRef, useState } from "react";
import { User } from "../types";
import { useAuth } from "../contexts/auth-context";
import { useLocation, useNavigate } from "react-router-dom";
import { authId, getImageUser, getImageUserNotFound, isMyLove } from "../utils/auth";
import { LogOut, UserPlus, X } from "react-feather";
import { BUCKET_PACOCA_URL } from "../utils/vars";
import Cookies from "js-cookie";
import { useTheme } from "../contexts/theme-context";
import { useTranslation } from "react-i18next";


interface AddAccountProps{
    isDropdownVisible?: boolean;
    setDropdownVisible: any;
    setOpen?: any;
    isMobile?: boolean;
    linkProfile?: string;
    bottomPadding?: number;
}

interface UserListLocalProps{
    clickItem?: () => void;
    linkProfile?: string;
}

export function AddAccount({ isDropdownVisible = false, setDropdownVisible, isMobile = false, setOpen, linkProfile, bottomPadding } : AddAccountProps){
    const [usersSessions, setUsersSessions] = useState<User[]>([]);
    const { logout, changeUser, addOtherAccount, isAuthenticated } = useAuth();
    const { isLiquidGlass, isDarkMode } = useTheme();
    const navigate = useNavigate();
    const { user } = useAuth();
    const longPressTimer = useRef<NodeJS.Timeout | null>(null);
    const [isLongPress, setIsLongPress] = useState(false);
    const longPressTime = 500;
    const [startPosition, setStartPosition] = useState<{ x: number; y: number } | null>(null);
    const [isScrolling, setIsScrolling] = useState(false);
    const [classDrop, setClassDrop] = useState(isMobile ? "dropdown-swicth-account-mobile" : "");
    const firstRun = useRef(true);
    const location = useLocation();
    const path = location.pathname;
    const { t } = useTranslation();
    const dropdownRef = useRef<HTMLDivElement>(null);
    const imgRef = useRef<HTMLImageElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node) &&
                imgRef.current &&
                !imgRef.current.contains(event.target as Node)
            ) {
                setDropdownVisible(false);
            }
        };

        window.addEventListener("click", handleClickOutside);
        return () => {
            window.removeEventListener("click", handleClickOutside);
        };
    }, []);

    // useEffect(() => {
    //     setDropdownVisible(dropdownVisible); // Remove o return, pois `setState` não pode ser retornado
    // }, [dropdownVisible]);

    useEffect(() => {
        let newClass = isMobile ? "dropdown-swicth-account-mobile " : "";
        newClass = newClass + (isMobile && isDropdownVisible ? "dropdown-swicth-account-mobile-visible" : "")
        setClassDrop(newClass); // Remove o return, pois `setState` não pode ser retornado
    }, [isDropdownVisible]);

    useEffect(() => {
        const users = JSON.parse(Cookies.get('saved_users') ?? "[]");
        setUsersSessions(users); // Remove o return, pois `setState` não pode ser retornado
    }, []);


    function handleLogout(){
        logout();
    }

    function handleAddAccount(){
        addOtherAccount();
        setDropdownVisible(false);
    }

    const dropdownPCStyle = {
        padding: "0",
        paddingTop: "5px",
        display: isDropdownVisible ? 'block' : 'none',
        position: 'absolute' as const,
        width: usersSessions.length >= 2 || (usersSessions.length === 1 && usersSessions[0].user_id !== authId()) ? '300px' : 'auto',
        right: usersSessions.length >= 2 || (usersSessions.length === 1 && usersSessions[0].user_id !== authId()) ? '10px' : '50px',
        top: '60px',
    };

    const dropdownStyle = {
        padding: "0",
        position: "absolute" as const,
        // width: usersSessions.length >= 2 || (usersSessions.length === 1 && usersSessions[0].user_id !== authId()) ? '100%' : '',
        width: !isLiquidGlass ? '100%' : 'calc(100% + 40px + 56px + 40px + 13px)',
        left: !isLiquidGlass ? '0' : '-40px',
        bottom: !isLiquidGlass ? '' : (bottomPadding ? ((bottomPadding + 25)  * -1) : '0px'),
        right: usersSessions.length >= 2 || (usersSessions.length === 1 && usersSessions[0].user_id !== authId()) ? '0' : '-5px',
    };

    const onPressStart = (type: "mouse" | "touch", e: any) => {
        // if (type == "mouse" && window.innerWidth <= 850) return;
        
        // Se estiver rolando, não inicia o long press
        if (isScrolling) {
            return;
        }
        
        setIsLongPress(false);
        setIsScrolling(false);

        // Salva posição inicial e o elemento
        const clientX = type === "touch" ? e.touches[0].clientX : e.clientX;
        const clientY = type === "touch" ? e.touches[0].clientY : e.clientY;
        setStartPosition({ x: clientX, y: clientY });

        longPressTimer.current = setTimeout(() => {
            if(setOpen) setOpen(true)
            else setDropdownVisible(true)
            setIsLongPress(true);
        }, longPressTime);
    };

    // Modifique o onPressEnd
    const onPressEnd = (type: "mouse" | "touch", e: any) => {
        // if (type === "mouse" && window.innerWidth <= 850) return;

        // Se estiver rolando, ignora completamente
        if (isScrolling) {
            return;
        }

        if (longPressTimer.current) {
            clearTimeout(longPressTimer.current);
            longPressTimer.current = null;
        }

        // Checa movimento (aumente um pouco o threshold para scroll)
        if (startPosition) {
            const clientX = type === "touch" ? e.changedTouches[0].clientX : e.clientX;
            const clientY = type === "touch" ? e.changedTouches[0].clientY : e.clientY;

            const dx = Math.abs(clientX - startPosition.x);
            const dy = Math.abs(clientY - startPosition.y);

            // Aumente o threshold para ser mais tolerante
            if (dx > 15 || dy > 15) { // ou ajuste conforme necessário
                // Moveu muito => provavelmente scroll, não seleciona
                return;
            }
        }

        if (!isLongPress) {
            navigate(`/@${user?.user_name}`);
        }
    };

    // Adicione também um onMouseMove/onTouchMove para cancelar o timer se houver movimento
    const onPressMove = (e: any, type: "mouse" | "touch") => {
        if (!startPosition || !longPressTimer.current) return;
        
        const clientX = type === "touch" ? e.touches[0].clientX : e.clientX;
        const clientY = type === "touch" ? e.touches[0].clientY : e.clientY;
        
        const dx = Math.abs(clientX - startPosition.x);
        const dy = Math.abs(clientY - startPosition.y);
        
        // Se mover além do threshold, cancela o long press
        if (dx > 10 || dy > 10) {
            if (longPressTimer.current) {
                clearTimeout(longPressTimer.current);
                longPressTimer.current = null;
            }
        }
    };

    useEffect(() => {
        if(path.includes("@") && !path.includes("chat")) return;
        if (firstRun.current) {
            firstRun.current = false; // ignora a primeira execução
            return;
        }
            
      if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') {
        window.ReactNativeWebView.postMessage(JSON.stringify({ statusBarStyle: isDropdownVisible ? (isDarkMode ? "#000000" : "#999999"): (isDarkMode ? "#000" : "#fff") }));
      }
  }, [isDropdownVisible]);
    
    return (
        <>
            

            <li className="nav-item">
                <img className="img-perfil-menu" 
                    src={getImageUser(user?.img_account, undefined, user?.name)}
                    ref={imgRef}
                    style={{backgroundImage: `url("${getImageUser(user?.img_account, undefined, user?.name)}")`, cursor: "pointer"}}
                    // onClick={() => navigate(`/@${user?.user_name}`)}
                    onMouseDown={(e) => onPressStart("mouse", e)}
                    onMouseUp={(e) => onPressEnd("mouse", e)}
                    onMouseMove={(e) => onPressMove(e, "mouse")}
                    onTouchStart={(e) => onPressStart("touch", e)}
                    onTouchEnd={(e) => onPressEnd("touch", e)}
                    onTouchMove={(e) => onPressMove(e, "touch")}
                    // onClick={showDropdown}
                    // onContextMenu={showDropdown}
                    onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }}
                />
                    
                <div ref={dropdownRef} id="accountsDropdown" style={isMobile ? dropdownStyle : dropdownPCStyle} className={`${classDrop} dropdown-menu`} aria-labelledby="dropdownMenuButton">
                    <UserListLocal linkProfile={linkProfile} clickItem={() => { setDropdownVisible(false); }}/>

                    <div className="">
                        <div className="line"></div>
                    </div>
                    
                    <div onClick={handleAddAccount} className='cursor-pointer btn-add-account-drop' style={{display: usersSessions.length < 5 ? "flex" : "none"}}>
                        <UserPlus/>
                        {t("user.addAccount")}
                    </div>

                    <div className="user-select-none cursor-pointer btn-exit-drop" onClick={handleLogout}>
                        <div className="img-switch">
                            <LogOut data-feather="log-out"/>
                        </div>
                        <p style={{margin: 0}}>Sair</p>
                    </div>
                </div>
            </li>

        </>
    )
}

export function UserListLocal({ clickItem, linkProfile }: UserListLocalProps){
    const [usersSessions, setUsersSessions] = useState<User[]>([]);
    const { user, logout, changeUser, isAuthenticated } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const users = JSON.parse(Cookies.get('saved_users') ?? "[]");
        setUsersSessions(users); // Remove o return, pois `setState` não pode ser retornado
    }, []);

    return (
        <>
            <span>
                <div onClick={() => {navigate(linkProfile ? linkProfile : `/@${user?.user_name}`); if(clickItem) clickItem();}} className="user-select-none switch-account cursor-pointer">
                    <div className="img-switch">
                        <img
                            src={getImageUser(user?.img_account, undefined, user?.name)}
                            alt={user?.name}
                            onError={(e) => { e.currentTarget.src = getImageUserNotFound(user?.name); }}
                        />
                    </div>
                    <div className="text-switch">
                        <h5>{isMyLove(user) ? "Meu amor" : user?.name?.split(" ")[0]}</h5>
                        <p className="dropdown-item">
                            @{user?.user_name}
                        </p>
                    </div>
                </div>
            </span>

            <div className="line"></div>

            {usersSessions.length >= 0 ? (
                <>
                    {usersSessions.map((userSession, index) => (
                        <span key={index}>
                            {userSession.id && userSession?.id != user?.id ? (
                                <div onClick={() => changeUser(userSession.id)} key={userSession.id} className="user-select-none switch-account cursor-pointer">
                                    <div className="img-switch">
                                        <img
                                            src={getImageUser(userSession.img_account, undefined, userSession.name)}
                                            alt={userSession.name}
                                            onError={(e) => { e.currentTarget.src = getImageUserNotFound(userSession.name); }}
                                        />
                                    </div>
                                    <div className="text-switch">
                                        <h5>{isMyLove(userSession) ? "Meu amor" : userSession?.name?.split(" ")[0]}</h5>
                                        <p className="dropdown-item">
                                            @{userSession?.user_name}
                                        </p>
                                    </div>
                                </div>
                            ) : null}
                        </span>
                    ))}
                </>
            ) : null}
        </>
    )
}